import { Charts } from './Charts';
import PeriodChartsDataProvider from './contexts/PeriodChartsDataContext';

const PeriodWrapper = () => {
    return (
        <PeriodChartsDataProvider>
            <Charts />
        </PeriodChartsDataProvider>
    );
};

export default PeriodWrapper;
